/** @jsxImportSource @emotion/react */

import {createContext, useContext} from 'react'

export const MainTabContext = createContext()
export const useMainTabContext = () => useContext(MainTabContext)
export const MainTabsContext = createContext()
export const useMainTabsContext = () => useContext(MainTabsContext)
